import { ColumnDef } from '@tanstack/react-table';
import { cn } from '../../../../../utils/styles';
import { IAccordionData } from '../../../Common/AccordionTable';
import { GuidanceViewPdfButton } from '../../Dashboard/Data';

function formatDateShort(date: Date): string {
  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
  };

  return date.toLocaleDateString('en-US', options);
}

function getDateForMonth(year: number, monthIndex: number, day: number): string {
  const date = new Date(year, monthIndex, day);

  return formatDateShort(date);
}

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth(); // 0-11

const noticesMonthsConfig = [
  {
    key: 'jan',
    day: 1,
    monthIndex: 0,
    description: 'Past due loan payment',
    pdfSrc: '/guidance/pdfs/pastDueLoanPayment.pdf',
  },
  {
    key: 'feb',
    day: 15,
    monthIndex: 1,
    description: 'ATM deposit adjustment notice',
    pdfSrc: '/guidance/pdfs/atmDepositAdjustmentNotice.pdf',
  },
  {
    key: 'mar',
    day: 15,
    monthIndex: 2,
    description: 'Delinquent account notice',
    pdfSrc: '/guidance/pdfs/delinquentAccountNotice.pdf',
  },
  {
    key: 'apr',
    day: 30,
    monthIndex: 3,
    description: 'Overdraft notice',
    pdfSrc: '/guidance/pdfs/overdraftNotice.pdf',
  },
];

function generateNoticesData(year: number): INoticesData[] {
  const availableMonths =
    year === currentYear ? noticesMonthsConfig.filter(m => m.monthIndex < currentMonth) : noticesMonthsConfig;

  return availableMonths.map((config, index) => ({
    id: String(index + 1),
    date: getDateForMonth(year, config.monthIndex, config.day),
    description: config.description,
    pdfSrc: config.pdfSrc,
  }));
}

export interface INoticesData {
  id: string;
  date: string;
  description: string;
  type?: 'Payroll' | string;
  pdfSrc?: string;
}

export const SEARCH_SUGGESTIONS = ['Payroll'];

export const noticesCol: ColumnDef<INoticesData>[] = [
  {
    header: 'Date',
    accessorKey: 'date',
    cell: ({ row }) => (
      <div className="flex items-center gap-[10px]">
        <div className={cn('w-[8px] h-[8px] rounded bg-addition8 uppercase')} />
        {row.getValue('date')}
      </div>
    ),
  },
  {
    header: 'Description',
    accessorKey: 'description',
  },
  {
    id: 'actions',
    accessorKey: '',
    header: 'Actions',
    size: 450,
    cell: ({ row }) => {
      return <GuidanceViewPdfButton src={row.original.pdfSrc} />;
    },
  },
];

const noticesData2026 = generateNoticesData(currentYear);
const noticesData2025 = generateNoticesData(currentYear - 1);

const lastAvailableDate2026 = noticesData2026[noticesData2026.length - 1]?.date || getDateForMonth(currentYear, 0, 1);

const noticesData2026WithSearch = [
  ...noticesData2026,
  {
    id: 'ach-1',
    date: lastAvailableDate2026,
    description: 'Address Change',
    type: 'Payroll',
    pdfSrc: '/guidance/otherDocs/bill_highlighted.pdf',
  },
];

export const noticesAccordion: IAccordionData<INoticesData>[] = [
  {
    id: '1',
    label: `Notices from ${currentYear}`,
    year: currentYear,
    data: noticesData2026WithSearch,
  },
  {
    id: '2',
    label: `Notices from ${currentYear - 1}`,
    year: currentYear - 1,
    data: noticesData2025,
  },
];
